import React from 'react';
import PropTypes from 'prop-types';
import './SkipLink.css';

/**
 * SkipLink - Accessibility skip navigation component
 * Allows keyboard users to skip repeated navigation and jump to main content
 */
const SkipLink = ({ targetId = 'main-content', children = 'Skip to main content' }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.tabIndex = -1;
      target.focus();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <a 
      href={`#${targetId}`} 
      className="skip-link"
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

SkipLink.propTypes = {
  targetId: PropTypes.string,
  children: PropTypes.node,
};

export default React.memo(SkipLink);
